var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgBalanceAccountsDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-balance-accounts-disabled_svg__cls-1,.kpmg-balance-accounts-disabled_svg__cls-4{fill:none}.kpmg-balance-accounts-disabled_svg__cls-1,.kpmg-balance-accounts-disabled_svg__cls-2{stroke-width:1.6px;stroke:#e5e2e2}.kpmg-balance-accounts-disabled_svg__cls-1{stroke-linecap:round}.kpmg-balance-accounts-disabled_svg__cls-2{fill:#fff}.kpmg-balance-accounts-disabled_svg__cls-3{stroke:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-balance-accounts-disabled_svg__ICN_Conturi_Enabled",
    transform: "translate(-635 -1435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-balance-accounts-disabled_svg__Line_633",
    "data-name": "Line 633",
    className: "kpmg-balance-accounts-disabled_svg__cls-1",
    transform: "translate(637.5 1437.5)",
    d: "M0 0h14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-balance-accounts-disabled_svg__Line_634",
    "data-name": "Line 634",
    className: "kpmg-balance-accounts-disabled_svg__cls-1",
    transform: "translate(637.5 1444.5)",
    d: "M0 0h14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-balance-accounts-disabled_svg__Line_635",
    "data-name": "Line 635",
    className: "kpmg-balance-accounts-disabled_svg__cls-1",
    transform: "translate(637.5 1450.5)",
    d: "M0 0h14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-balance-accounts-disabled_svg__Ellipse_219",
    "data-name": "Ellipse 219",
    className: "kpmg-balance-accounts-disabled_svg__cls-2",
    transform: "translate(635 1435)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-balance-accounts-disabled_svg__cls-3",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-balance-accounts-disabled_svg__cls-4",
    cx: 2.5,
    cy: 2.5,
    r: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-balance-accounts-disabled_svg__Ellipse_220",
    "data-name": "Ellipse 220",
    className: "kpmg-balance-accounts-disabled_svg__cls-2",
    transform: "translate(640 1435)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-balance-accounts-disabled_svg__cls-3",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-balance-accounts-disabled_svg__cls-4",
    cx: 2.5,
    cy: 2.5,
    r: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-balance-accounts-disabled_svg__Ellipse_221",
    "data-name": "Ellipse 221",
    className: "kpmg-balance-accounts-disabled_svg__cls-2",
    transform: "translate(649 1435)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-balance-accounts-disabled_svg__cls-3",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-balance-accounts-disabled_svg__cls-4",
    cx: 2.5,
    cy: 2.5,
    r: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-balance-accounts-disabled_svg__Ellipse_222",
    "data-name": "Ellipse 222",
    className: "kpmg-balance-accounts-disabled_svg__cls-2",
    transform: "translate(644 1442)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-balance-accounts-disabled_svg__cls-3",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-balance-accounts-disabled_svg__cls-4",
    cx: 2.5,
    cy: 2.5,
    r: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-balance-accounts-disabled_svg__Ellipse_223",
    "data-name": "Ellipse 223",
    className: "kpmg-balance-accounts-disabled_svg__cls-2",
    transform: "translate(649 1448)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-balance-accounts-disabled_svg__cls-3",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-balance-accounts-disabled_svg__cls-4",
    cx: 2.5,
    cy: 2.5,
    r: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-balance-accounts-disabled_svg__Ellipse_225",
    "data-name": "Ellipse 225",
    className: "kpmg-balance-accounts-disabled_svg__cls-2",
    transform: "translate(635 1448)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-balance-accounts-disabled_svg__cls-3",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-balance-accounts-disabled_svg__cls-4",
    cx: 2.5,
    cy: 2.5,
    r: 1.7
  })))));
}

export default SvgKpmgBalanceAccountsDisabled;